
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Conjunctival_carcinoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Conjunctival_carcinoma.vue